import { Pipe, PipeTransform, inject } from '@angular/core';
import { ScoringDefinitionService } from '../scoring-definition.service';
import { Observable, map, of } from 'rxjs';
import { ObjectType } from '@galaxy/crm/static';
import { GalaxyFilterOperator } from '@vendasta/galaxy/filter/chips';
import { isAcceptedObjectType } from '../../validators';

@Pipe({
  name: 'supportedOperators',
  standalone: false,
})
export class SupportedOperatorsPipe implements PipeTransform {
  private readonly scoringDefinitionService = inject(ScoringDefinitionService);

  transform(value?: string | null, objectType?: ObjectType): Observable<GalaxyFilterOperator[]> {
    if (!value) {
      return of([]);
    }
    if (!isAcceptedObjectType(objectType)) {
      return of([]);
    }
    return this.scoringDefinitionService.getObjectFilters$(objectType).pipe(
      map((filters) => filters?.find((f) => f.fieldId === value)),
      map((filter) => filter?.supportedOperators ?? []),
    );
  }
}
